export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/ixNK8cnB7umVjwcr4cgqkh/ChatGPT-Image-12-jul-2026_-08_47_19-p.m..webp'

export const PRODUCT_NAME = 'STRENGTH READY™'

export const CHECKOUT_URL = 'https://strength-ready.impultienda.ar/checkout'
